import { render, staticRenderFns } from "./CoFormText.vue?vue&type=template&id=261010aa&scoped=true&"
import script from "./CoFormText.vue?vue&type=script&lang=js&"
export * from "./CoFormText.vue?vue&type=script&lang=js&"
import style0 from "./CoFormText.vue?vue&type=style&index=0&id=261010aa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261010aa",
  null
  
)

export default component.exports